export const api = {
  task: {
        // 接口用于查询布控任务列表
        queryVehicleTask: '/vas/vehicleControl/queryVehicleTask.json',
        // 删除布控
        deleteVehicleTask: '/vas/vehicleControl/deleteVehicleTask.json',
        // 启用、停用任务
        openCloseVehicleTask: '/vas/vehicleControl/startStopVehicleTask.json',
        // 添加布控任务
        addVehicleTask: '/vas/vehicleControl/addVehicleTask.json',
        // 修改布控任务
        updateVehicleTask: '/vas/vehicleControl/updateVehicleTask.json',
        // 查询布控详情
        queryVehicleTaskDetails: '/vas/vehicleControl/queryVehicleTaskDetails.json',
        // 查询黑名单
        queryVehicleGroup: '/vas/vehicleRepositories/queryVehicleGroupByType.json',
        /*车辆布控获取车辆详情*/
        queryBwPlatByRepositorCodes: '/vas/vehicleRepositories/queryBwPlatByRepositorCodes.json',
        // 获取摄像机组下的摄像机
        queryCameralist: '/vas/bayonet/queryCameralist.json',
  }
}
